import React from 'react'
import ReactDOM from 'react-dom';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom"
import * as Routes from '../constants/routes'
// import {MainContextProvider} from "../context/mainContext";
import { HomePage } from '../pages/home';
import { YouMayLike } from '../pages/home/youMayLike';
// import { Popup } from '../components/advanced/popup'
// import { Page } from '../components/basic/layout'
import { AppData } from '../data'

const App = () => {

  const productDetails = () => {
    ReactDOM.render(<HomePage appData={AppData} />, document.getElementById('product-details'));
    ReactDOM.render(<YouMayLike appData={AppData} />, document.getElementById('you-may-like'));
	}

  return (
    <Router>
      {/* <MainContextProvider>
        <Popup /> */}
          <Switch>
            <Route path={Routes.HOME}>
              {/* <HomePage appData={AppData} /> */}
              {productDetails()}
            </Route>
          </Switch>
      {/* </MainContextProvider> */}
    </Router>
  )
}

export default App
